<template>
  <div :class="containerClass" @click="onWrapperClick">
    <AppTopBar @menu-toggle="onMenuToggle" v-if="loggedIn && !isGuest" />
    <Toast />
    <transition name="layout-sidebar" >
      <div
        v-if="loggedIn && !isGuest"
        :class="sidebarClass"
        @click="onSidebarClick"
        v-show="isSidebarVisible()"
      >
        <div class="layout-logo p-mt-auto">
          <router-link to="/">
            <img alt="Logo" :src="logo" width="160" height="60" class="p-m-2" />
          </router-link>
        </div>
        <AppProfile />
        <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
      </div>
    </transition>

    <div :class="{'layout-main-full': this.isGuest, 'layout-main': !this.isGuest}">
      <router-view />
    </div>

    <AppConfig
      :layoutMode="layoutMode"
      :layoutColorMode="layoutColorMode"
      @layout-change="onLayoutChange"
      @layout-color-change="onLayoutColorChange"
    />

    <AppFooter v-if="false" />
  </div>
</template>

<script>
import AppConfig from './AppConfig.vue';
import AppFooter from './AppFooter.vue';
import AppMenu from './AppMenu.vue';
import AppProfile from './AppProfile.vue';
import AppTopBar from './AppTopbar.vue';
import { isUserAdmin, isUserGuest } from './helpers/security';

export default {
  data() {
    const isAdmin = isUserAdmin();
    const isGuest = isUserGuest();


    return {
      isGuest,
      layoutMode: 'static',
      layoutColorMode: 'dark',
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      menu: [
        { label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' },
        { label: 'Plantillas', icon: 'pi pi-fw pi-clone', to: '/plantillas' },
        { label: 'Envios CSV  ', icon: 'pi pi-fw pi-file-excel', to: '/csv' },
        {
          label: 'Envios Email',
          icon: 'pi pi-fw pi-envelope',
          to: '/emailconfig',
        },
        { label: 'Evidencias  ', icon: 'pi pi-fw pi-clone', to: '/evidencia' },        
        {
          label: 'Seguridad',
          icon: 'pi pi-fw pi-key',
          items: [
            {
              label: 'Empresas',
              icon: 'pi pi-fw pi-calendar',
              to: '/empresas',
            },
            isAdmin && {
              label: 'Usuarios',
              icon: 'pi pi-fw pi-user-edit',
              to: '/usuarios',
            },
            isAdmin && {
              label: 'Roles',
              icon: 'pi pi-fw pi-users',
              to: '/roles',
            },
          ],
        },
      ],
    };
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
    },
  },
  methods: {
    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }

      this.menuClick = false;
    },
    onMenuToggle() {
      this.menuClick = true;

      if (this.isDesktop()) {
        if (this.layoutMode === 'overlay') {
          if (this.mobileMenuActive === true) {
            this.overlayMenuActive = true;
          }

          this.overlayMenuActive = !this.overlayMenuActive;
          this.mobileMenuActive = false;
        } else if (this.layoutMode === 'static') {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }

      event.preventDefault();
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
    },
    onLayoutChange(layoutMode) {
      this.layoutMode = layoutMode;
    },
    onLayoutColorChange(layoutColorMode) {
      this.layoutColorMode = layoutColorMode;
    },
    addClass(element, className) {
      if (element.classList) element.classList.add(className);
      else element.className += ' ' + className;
    },
    removeClass(element, className) {
      if (element.classList) element.classList.remove(className);
      else
        element.className = element.className.replace(
          new RegExp(
            '(^|\\b)' + className.split(' ').join('|') + '(\\b|$)',
            'gi'
          ),
          ' '
        );
    },
    isDesktop() {
      return window.innerWidth > 1024;
    },
    isSidebarVisible() {
      if (this.isDesktop()) {
        if (this.layoutMode === 'static') return !this.staticMenuInactive;
        else if (this.layoutMode === 'overlay') return this.overlayMenuActive;
        else return true;
      } else {
        return true;
      }
    },
  },
  computed: {
    containerClass() {
      return [
        'layout-wrapper',
        {
          'layout-overlay': this.layoutMode === 'overlay',
          'layout-static': this.layoutMode === 'static',
          'layout-static-sidebar-inactive':
            this.staticMenuInactive && this.layoutMode === 'static',
          'layout-overlay-sidebar-active':
            this.overlayMenuActive && this.layoutMode === 'overlay',
          'layout-mobile-sidebar-active': this.mobileMenuActive,
          'p-input-filled': this.$appState.inputStyle === 'filled',
          'p-ripple-disabled': this.$primevue.config.ripple === false,
        },
      ];
    },
    sidebarClass() {
      return [
        'layout-sidebar',
        {
          'layout-sidebar-dark': this.layoutColorMode === 'dark',
          'layout-sidebar-light': this.layoutColorMode === 'light',
        },
      ];
    },
    logo() {
      return this.layoutColorMode === 'dark'
        ? 'assets/layout/images/logoAbSign.png'
        : 'assets/layout/images/logoAbSign.png';
    },
    loggedIn() {
      return this.$store.state.authentication.status.loggedIn;
    },
  },
  beforeUpdate() {
    if (this.mobileMenuActive)
      this.addClass(document.body, 'body-overflow-hidden');
    else this.removeClass(document.body, 'body-overflow-hidden');
  },
  components: {
    AppTopBar: AppTopBar,
    AppProfile: AppProfile,
    AppMenu: AppMenu,
    AppConfig: AppConfig,
    AppFooter: AppFooter,
  },
};
</script>

<style lang="scss">
@import './App.scss';
</style>
